<template>
  <div class="roleMeal table-hook fadeInRight">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="套餐显示规则管理" name="first">
        <div class="title-box">
          <el-form
            inline
            class="hook right themed-form search-form"
            style="line-height: 40px"
            :model="queryForm"
          >
            <el-form-item label="规则名称:">
              <el-input v-model="queryForm.name"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                class="themed-button"
                @click="searchTable"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-plus"
                class="themed-button"
                @click="addRecord"
                >新增</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                :disabled="!multiple"
                icon="el-icon-remove"
                class="themed-button"
                @click="removeRecord"
                >删除</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="content-box">
          <el-table
            ref="table"
            :data="tableData"
            @selection-change="handleSelectionChange"
            stripe
            border
            :max-height="maxTableHeight"
          >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column
              label="规则名称"
              prop="name"
              width="180px"
            ></el-table-column>
            <el-table-column
              label="套餐列表"
              prop=""
              width="180px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-link type="primary" @click="handleMealList(scope.row.id)"
                  >添加套餐</el-link
                >
              </template>
            </el-table-column>
            <el-table-column
              label="用户列表"
              prop=""
              width="180px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-link type="primary" @click="handleUserList(scope.row.id)"
                  >分配用户</el-link
                >
              </template>
            </el-table-column>
            <el-table-column
              label="备注"
              prop="remark"
              width="180px"
            ></el-table-column>
            <el-table-column
              label="操作人"
              prop="createUserName"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.createUser">{{
                  scope.row.createUser
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作时间"
              prop="updateTime"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.updateTime">{{
                  scope.row.updateTime
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" prop="createUserName" width="300px">
              <template slot-scope="scope">
                <el-button
                  type="info"
                  class="themed-button"
                  @click="updateRecord(scope.row)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[5, 10, 15, 50, 100, 1000]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
        <el-dialog
          title="套餐显示规则编辑"
          :visible.sync="dialogVisible"
          v-if="dialogVisible"
          @close="closeAddOrEditDialog()"
        >
          <el-form
            label-position="right"
            label-width="200px"
            :model="addOrEditForm"
            ref="addOrEditForm"
            :rules="rules"
          >
            <el-form-item label="名称:" required prop="name">
              <el-input
                v-model="addOrEditForm.name"
                maxlength="150"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="备注:" prop="remark">
              <el-input
                v-model="addOrEditForm.remark"
                type="textarea"
                placeholder="请输入内容"
                maxlength="255"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm()">确 定</el-button>
            <el-button @click="cancle()">取 消</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="公众号套餐分类" name="second">
        <meal-sort></meal-sort>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  mealRulesList,
  saveMealRules,
  updateMealRules,
  deleteMealRules,
} from "@/api/setMealManagment/mealRules.js";
import { messageBox, confirmBox } from "@/utils/common.js";
import store from "@/store";
import {
  getConfigurationModify,
  setConfigurationModify,
} from "@/api/systemManagement.js";
import resize from "@/mixins/resize.js";
import MealSort from "./mealSort.vue";

export default {
  name: "mealRules",
  components: {
    MealSort
  },
  mixins: [resize],
  data() {
    
    return {
     
      ids: [],
      multiple: false,
      queryForm: {
        name: "",
      },
      tableData: [],
      pageNo: 1,
      pageSize: 15,
      total: 0,
      dialogVisible: false,
      addOrEditForm: {
        id: undefined,
        name: "",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
    
      activeName: "first",
    
    };
  },
  mounted() {
    this._mealRulesList();
    this.mealTypeList();
  },
  methods: {
      handleClick(tab, event) {
        if(tab.name=="first"){
         this._mealRulesList();
        }else{
        this.mealTypeList();
        }
      },
   
   

    mealTypeList() {
     
    },
   
   
    

    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.multiple = selection && selection.length > 0;
    },
    submitForm() {
      this.$refs["addOrEditForm"].validate((valid) => {
        if (valid) {
          let params = {};
          if (!!this.addOrEditForm.id) {
            params = {
              id: this.addOrEditForm.id,
              name: this.addOrEditForm.name,
              remark: this.addOrEditForm.remark,
            };
            updateMealRules(params)
              .then((res) => {
                this._mealRulesList();
                this.dialogVisible = false;
                this.resetForm();
                this.$message({
                  showClose: true,
                  message: "保存成功",
                  type: "success",
                });
              })
              .catch(() => {});
          } else {
            params = {
              name: this.addOrEditForm.name,
              remark: this.addOrEditForm.remark,
            };
            saveMealRules(params)
              .then((res) => {
                this._mealRulesList();
                this.dialogVisible = false;
                this.resetForm();
                this.$message({
                  showClose: true,
                  message: "保存成功",
                  type: "success",
                });
              })
              .catch(() => {});
          }
        } else {
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    cancle() {
      this.dialogVisible = false;
      this.resetForm();
    },

    resetForm() {
      this.addOrEditForm.id = undefined;
      this.addOrEditForm.name = "";
      this.addOrEditForm.remark = "";
    },

    searchTable() {
      this._mealRulesList();
    },
    addRecord() {
      this.dialogTitle = "新增套餐";
      this.dialogContent = "add";
      this.dialogVisible = true;
    },
    updateRecord(row) {
      this.dialogVisible = true;
      this.addOrEditForm.id = row.id;
      this.addOrEditForm.name = row.name;
      this.addOrEditForm.remark = row.remark;
    },
    closeAddOrEditDialog() {
      this.resetForm();
    },
    removeRecord() {
      if (!this.ids || this.ids.length == 0) {
        this.$alert("请选择数据!", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$confirm("确认要删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            ids: this.ids.join(","),
          };
          deleteMealRules(params)
            .then((res) => {
              this._mealRulesList();
              this.multiple = false;
              this.ids = [];
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
            })
            .catch(() => {
              this.multiple = false;
              this.ids = [];
              this.$message({
                showClose: true,
                message: "删除失败",
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.pageSize = val;
      //this._mealRulesList()
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this._mealRulesList();
    },
    _mealRulesList() {
      let params = Object.assign(this.queryForm, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      mealRulesList(params).then((res) => {
        this.pageNo = res.pageNo;
        this.pageSize = res.pageSize;
        this.total = res.total;
        this.tableData = res.rows;
      });
    },
    handleMealList(rowId) {
      //this.$router.push({ path: '/task/detail', query: { id: row.id} });
      this.$router
        .push({ path: "/mealRules/mealList/" + rowId })
        .catch(() => true);
    },
    handleUserList(rowId) {
      this.$router
        .push({ path: "/mealRules/userList/" + rowId })
        .catch(() => true);
    },
  },
};
</script>
